/**
 * Orchestration metadata for the single-order Postgres domain fetches.
 * @module dataAccumulator/singleOrderDomainConfig
 */
import { SingleOrderDetailsTableName } from "../../enums/singleOrderDetailsTableName";
import { SingleOrderDomainInstances } from "./types";

/** Metadata describing how a domain participates in fetch orchestration. */
export interface SingleOrderDomainOrchestrationEntry {
  /** Whether this domain contributes to the combined `loading` flag. */
  includeInCombinedLoading: boolean;
}

/** Orchestration flags keyed by {@link SingleOrderDomainInstances} id. */
export const SINGLE_ORDER_DOMAIN_ORCHESTRATION: Record<
  keyof SingleOrderDomainInstances,
  SingleOrderDomainOrchestrationEntry
> = {
  generalOrderDetails: { includeInCombinedLoading: true },
  authOnFileDetails: { includeInCombinedLoading: true },
  clinicalData: { includeInCombinedLoading: true },
  commentsData: { includeInCombinedLoading: true },
  coverageDetails: { includeInCombinedLoading: true },
  workflowConfig: { includeInCombinedLoading: true },
  reviewsData: { includeInCombinedLoading: true },
  clinicalConditions: { includeInCombinedLoading: true },
  authorizationData: { includeInCombinedLoading: true },
  submissionData: { includeInCombinedLoading: true },
  siblingOrders: { includeInCombinedLoading: true },
};

/** Fixed-order list of domain ids for orchestration iteration. */
export const SINGLE_ORDER_DOMAIN_IDS = Object.keys(
  SINGLE_ORDER_DOMAIN_ORCHESTRATION,
) as (keyof SingleOrderDomainInstances)[];

/** Postgres table names keyed by domain id (used when wiring fetch callbacks). */
export const SINGLE_ORDER_DOMAIN_TABLE_NAMES: Record<
  keyof SingleOrderDomainInstances,
  SingleOrderDetailsTableName
> = {
  generalOrderDetails:
    SingleOrderDetailsTableName.MEDICAL_PA_ORDER_GENERAL_INFO,
  authOnFileDetails: SingleOrderDetailsTableName.AUTH_ON_FILE,
  clinicalData: SingleOrderDetailsTableName.CLINICAL_DATA,
  commentsData: SingleOrderDetailsTableName.ORDER_COMMENTS,
  coverageDetails: SingleOrderDetailsTableName.COVERAGE,
  workflowConfig: SingleOrderDetailsTableName.WORKFLOW_CONFIG,
  reviewsData: SingleOrderDetailsTableName.REVIEWS,
  clinicalConditions: SingleOrderDetailsTableName.CLINICAL_CONDITIONS,
  authorizationData: SingleOrderDetailsTableName.AUTHORIZATION,
  submissionData: SingleOrderDetailsTableName.SUBMISSION,
  siblingOrders: SingleOrderDetailsTableName.SIBLING_ORDERS,
};
